import {
  RECEIVE_TRADE_SUPPORTING_DOCUMENTS,
  CREATE_TRADE_SUPPORTING_DOCUMENTS,
  REMOVE_TRADE_SUPPORTING_DOCUMENT,
  REMOVE_TRADE_SUPPORTING_DOCUMENTS,
} from "../actionTypes.js";

export default function tradeSupportingDocuments(state = [], action) {
  switch(action.type) {
    case RECEIVE_TRADE_SUPPORTING_DOCUMENTS:
      return action.payload;
    case CREATE_TRADE_SUPPORTING_DOCUMENTS:
      return state.concat(action.payload);
    case REMOVE_TRADE_SUPPORTING_DOCUMENT:
      const removedDoc = state.filter((item) => {
        return item.id !== action.payload;
      });

       return removedDoc;
    case REMOVE_TRADE_SUPPORTING_DOCUMENTS:
      return [];
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/supporting_documents/reducers/supportingDocuments.js